var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCompareActived(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756800421243,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3407,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 64m8 0l48 0q8 0 8 8l0 880q0 8-8 8l-48 0q-8 0-8-8l0-880q0-8 8-8Z",
    "p-id": 3408,
    fill: "#006EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 800V224h248a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H96a32 32 0 0 0-32 32v640a32 32 0 0 0 32 32h280a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z",
    "p-id": 3409,
    fill: "#006EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M640 800m8 0l112 0q8 0 8 8l0 48q0 8-8 8l-112 0q-8 0-8-8l0-48q0-8 8-8Z",
    "p-id": 3410,
    fill: "#006EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M640 160m8 0l112 0q8 0 8 8l0 48q0 8-8 8l-112 0q-8 0-8-8l0-48q0-8 8-8Z",
    "p-id": 3411,
    fill: "#006EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M896 800h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h88a32 32 0 0 0 32-32v-88a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8zM896 160h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-88a32 32 0 0 0-32-32z",
    "p-id": 3412,
    fill: "#006EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M896 480m0-8l0-112q0-8 8-8l48 0q8 0 8 8l0 112q0 8-8 8l-48 0q-8 0-8-8Z",
    "p-id": 3413,
    fill: "#006EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M896 672m0-8l0-112q0-8 8-8l48 0q8 0 8 8l0 112q0 8-8 8l-48 0q-8 0-8-8Z",
    "p-id": 3414,
    fill: "#006EFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompareActived);
export default __webpack_public_path__ + "static/media/IconCompareActived.6a129cb6adbc7c2a12e277fd9dffd587.svg";
export { ForwardRef as ReactComponent };